import { toast } from "react-toastify";
import { userLoginAPI } from "../../components/api/ClientApi";
import { withCookies, Cookies } from "react-cookie";
export const USER_LOGIN = "USER_LOGIN";
export const FETCH_USER_LOGIN = "FETCH_USER_LOGIN";
export const FETCH_USER_ERROR = "FETCH_USER_ERROR";
export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";
export const USER_LOGOUT = "USER_LOGOUT";

export const handleLoginRedux = (email, password) => {
  return async (dispatch, getState) => {
    dispatch({ type: FETCH_USER_LOGIN });
    userLoginAPI({ email: email, password: password }).then((response) => {
      let { errorCode, message } = response;
      if (errorCode === 0) {
        dispatch({
          type: FETCH_USER_SUCCESS,
          data: { token: response.data.token },
        });
        // loginContext({ account: JSON.stringify(data) });
      } else {
        toast.error(message);
        dispatch({
          type: FETCH_USER_ERROR,
        });
      }
    });
  };
};

export const handleLogoutRedux = () => {
  return async (dispatch, getState) => {
    dispatch({
      type: USER_LOGOUT,
      data: { token: "" },
    });
  };
};
